"use client";

// THE APP'S ONE DOOR TO NEXT'S ROUTER.
//
// useRouter() from next/navigation with push and replace that ask the stale
// tab first (lib/stale-tab.ts): after a release, a move to another page is a
// document load, so the page arrives on the new client. Everything else, the
// same router: back, forward, refresh, prefetch, and a query-only push or
// replace on the same page, which is a filter and not a break point.
//
// The lint refuses next/navigation's useRouter outside this file
// (eslint.config.mjs), so a new router.push cannot quietly skip the check.

import { useRouter } from "next/navigation";
import { useMemo } from "react";
import { staleTab, type StaleTab } from "./stale-tab";

export type AppRouter = ReturnType<typeof useRouter>;

/** `tab` is the tests'; the app always uses the shared one. */
export function useAppRouter(tab: StaleTab = staleTab()): AppRouter {
  const router = useRouter();
  return useMemo<AppRouter>(() => ({
    ...router,
    // The arguments pass through as given: a push with no options is still one.
    push: (...args) => {
      if (!tab.loadInstead(args[0], "push")) router.push(...args);
    },
    replace: (...args) => {
      if (!tab.loadInstead(args[0], "replace")) router.replace(...args);
    },
  }), [router, tab]);
}
